import React from 'react';
import { Breadcrumb, Col, Layout } from 'antd';
import { Link } from 'react-router-dom';
import AddNewUser from './components/User_create_table';

const BreadcrumbItem = Breadcrumb.Item;
const breadcrumb_position = { margin: '0 0 1% 0' };
const layout_position = { padding: '0 4%' };

export const User_create = () => (
    <Layout style={layout_position}>
        <Col span={24}>
            <Breadcrumb style={breadcrumb_position}>
                <BreadcrumbItem><Link to="/UserManagement/User_list">User Management</Link></BreadcrumbItem>
                <BreadcrumbItem>Invite User</BreadcrumbItem>
            </Breadcrumb>
            <h3 className="page-title">Invite User</h3>
            <h3 className="page-subhead subhead">
                Complete the details below to invite a new user to the platform
            </h3>
        </Col>
        <AddNewUser />
    </Layout>
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/index.js